import { Skeleton } from '@design-system/Skeleton';
import { StandardContainer } from '@design-system/StandardContainer';

interface DoctorsNoteShimmerProps {
  'data-testid'?: string;
}

const DoctorsNoteShimmer = ({ 'data-testid': testId }: DoctorsNoteShimmerProps = {}) => {
  return (
    <StandardContainer>
      <div className="mt-8 flex flex-col gap-3 select-none" data-testid={testId}>
        <Skeleton className="w-1/3 h-8" data-testid="healthL2Details-doctorsNoteTitleSkeleton" />

        <div className="grid sm:grid-cols-3 grid-cols-2 gap-4 w-full h-full" data-testid="healthL2Details-doctorsNoteCardsSkeleton">
          {[1, 2].map((_, index) => (
            <Skeleton
              key={`grid-skeleton-${index}`}
              className={`w-full h-60 rounded-lg block`}
              data-testid={`healthL2Details-doctorsNoteCardSkeleton-${index}`}
            />
          ))}
        </div>
      </div>
    </StandardContainer>
  );
};

export default DoctorsNoteShimmer;
